import { Shield } from "lucide-react";

const TIER_STYLE = {
  elite: { cls: "text-white border border-white/20",               label: "Very reliable" },
  solid: { cls: "text-white border border-white/20",               label: "Reliable" },
  mixed: { cls: "text-zinc-300 border border-white/20",            label: "Mixed record" },
  risky: { cls: "text-red-400 border border-red-500/40",           label: "Unreliable" },
  new:   { cls: "text-zinc-400 border border-white/10",            label: "New" },
};

export default function ReliabilityPill({ reliability, size = "sm", testid }) {
  if (!reliability) return null;
  const tier = reliability.tier || "new";
  const meta = TIER_STYLE[tier] || TIER_STYLE.new;
  const label = reliability.score != null ? `${reliability.score} · ${meta.label}` : meta.label;
  const sizeCls = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
  const iconSize = size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3";
  const title = reliability.score != null
    ? `Reliability ${reliability.score}/100 — ${meta.label} · ${reliability.review_count || 0} reviews${reliability.late_cancel_90d ? `, ${reliability.late_cancel_90d} late-cancel(s) 90d` : ""}${reliability.no_show_count ? `, ${reliability.no_show_count} no-show(s)` : ""}`
    : "Not enough completed jobs to score yet";
  return (
    <span
      className={`inline-flex items-center gap-1 uppercase tracking-widest font-bold ${sizeCls} ${meta.cls}`}
      title={title}
      data-testid={testid}
    >
      <Shield className={iconSize} strokeWidth={2.5} /> {label}
    </span>
  );
}
